export default __webpack_public_path__ + "static/media/dataviz-streetfood.cf9fd66b.png";